import Vue from "vue";
import Router from "vue-router";
import Header from "./layout/starter/StarterHeader";
import Footer from "./layout/starter/StarterFooter";
import Starter from "./views/Starter.vue";
import Components from "./views/Components.vue";
import Solutions from "./views/Solutions.vue";
import SolutionID from "./views/SolutionID.vue";
import Products from "./views/Products.vue";
import ProductID from "./views/ProductID.vue";
import Reviews from "./views/Reviews.vue";
import News from "./views/News.vue";
import NewID from "./views/NewID.vue";
import Contacts from "./views/Contacts.vue";
import About from "./views/About.vue";
import Videos from "./views/Videos.vue";
import Prices from "./views/Prices.vue";
import Pages from "./views/Pages.vue";
import Faq from "./views/Faq.vue";


Vue.use(Router);

export default new Router({
    linkExactActiveClass: "active",
    mode: "history",
  routes: [
    {
      path: "/",
      name: "starter",
      components: {
        header: Header,
        default: Starter,
        footer: Footer
      }
    },
    {
        path: "/components",
        name: "components",
        components: {
            header: Header,
            default: Components,
            footer: Footer
        }
      },
      {
          path: "/products",
          name: "Продукты",
          components: {
              header: Header,
              default: Products,
              footer: Footer
          }
      },
      {
          path: "/product/:id",
          name: "ProductID",
          components: {
              header: Header,
              default: ProductID,
              footer: Footer
          }
      },
      {
          path: "/solutions",
          name: "Решения",
          components: {
              header: Header,
              default: Solutions,
              footer: Footer
          }
      },
      {
          path: "/solution/:id",
          name: "SolutionID",
          components: {
              header: Header,
              default: SolutionID,
              footer: Footer
          }
      },
      {
        path: "/reviews",
        name: "Reviews",
        components: {
            header: Header,
            default: Reviews,
            footer: Footer
        }
      },
      {
          path: "/news",
          name: "Новости",
          components: {
              header: Header,
              default: News,
              footer: Footer
          }
      },
      {
          path: "/new/:id",
          name: "NewID",
          components: {
              header: Header,
              default: NewID,
              footer: Footer
          }
      },
      {
          path: "/contacts",
          name: "Contacts",
          components: {
              header: Header,
              default: Contacts,
              footer: Footer
          }
      },
      {
          path: "/about",
          name: "About",
          components: {
              header: Header,
              default: About,
              footer: Footer
          }
      },
      {
      path: "/videos",
          name: "Videos",
          components: {
              header: Header,
              default: Videos,
              footer: Footer
          }
      },
      {
        path: "/prices",
            name: "prices",
            components: {
                header: Header,
                default: Prices,
                footer: Footer
            }
      },
      {
      path: "/frequently-asked-questions",
            name: "faq",
            components: {
                header: Header,
                default: Faq,
                footer: Footer
            }
      },
      {
        path: "*",
        name: "pages",
        components: {
          default: Pages,
          header: Header,
          footer: Footer
        }
      }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});
